import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import MaterialIcon from '../../common/components/MaterialIcon';

// 内联文案：自定义 UI 不依赖扩展语言资产
const STR = {
  'zh-Hans': {
    sloganPre: '上',
    sloganBrand: '木棉Plus',
    sloganSep: '，',
    sub: '华工人的网上精神家园',
    login: '登录',
    signup: '注册',
    about: '关于',
    covenant: '社区公约',
    alumni: '校友申请',
    footer: '© 2026 华南木棉 Plus · 学生自发开发运营 · 永不收费'
  },
  en: {
    sloganPre: '',
    sloganBrand: 'Kapok Plus',
    sloganSep: ', ',
    sub: 'The online home for SCUT people',
    login: 'Log in',
    signup: 'Sign up',
    about: 'About',
    covenant: 'Covenant',
    alumni: 'Alumni',
    footer: '© 2026 SCUT Kapok Plus · Student-run · Free forever'
  }
};
const t = k => {
  const locale = app.translator && app.translator.locale || 'zh-Hans';
  const pack = STR[locale] || STR['zh-Hans'];
  return pack[k] || STR['zh-Hans'][k];
};

// 主 slogan 的后半句，每次刷新随机一个
const SLOGAN_SUFFIX = ['畅所欲言', '结交同好', '选你所选', '说说心里话', '找找同路人', '回家看看'];

// 不同深度的蓝色背景（每次刷新随机一套）
const BLUE_THEMES = [['#072f4f', '#0e4d7f', '#166395'], ['#0a3d62', '#166395', '#1e78b5'], ['#0e4d7f', '#1a6fa8', '#3d8ec9'], ['#166395', '#2e7cb8', '#4a94cc'], ['#1e78b5', '#3d8ec9', '#6fb1dd']];

// 词云：[版面, 语录, top%, left%, 字号, 旋转deg, 动画延迟s]
// 排布模仿高校 BBS 首页：集中在上半屏，松散云状；版面用本站的 7 个版
const QUOTES = [['建议', '@站长 加个夜间模式吧', 2, 44, 14, 0, 0.05], ['笑话', '今天食堂又整活了', 4, 24, 13, -2, 0.15], ['水帖', '课间摸鱼第 108 天', 8, 22, 13, 0, 0.25], ['学术', '求一份保研定位参考', 7, 42, 14, 0, 0.35], ['技巧', '学长学姐救救我', 9, 60, 13, 0, 0.45], ['求助', '急！在线等', 3, 66, 14, 0, 0.55], ['二手交易', '出九成新自行车', 6, 54, 13, 0, 0.65], ['笑话', '木棉花开了一地', 12, 68, 13, 0, 0.75], ['水帖', '图书馆三楼靠窗位永远有人', 11, 26, 13, 0, 0.85], ['学术', '这份笔记救了我一命', 15, 40, 14, 0, 0.95], ['技巧', '选课求带', 14, 56, 14, 0, 1.05], ['求助', '750 宿舍是什么体验', 17, 70, 13, 0, 1.15], ['二手交易', '收一个二手显示器', 18, 26, 13, 0, 1.25], ['笑话', '……', 12, 34, 16, 0, 1.35], ['水帖', '……', 8, 50, 15, 0, 1.45], ['建议', '……', 16, 62, 15, 0, 1.55]];

// Material mouse（域名框右侧的鼠标图标）
const MOUSE_PATH = 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.51 4 4.87 4 8.96V9h7V1.07z';
const pick = arr => arr[Math.floor(Math.random() * arr.length)];

/**
 * 游客默认落地页（仿高校 BBS 首页）：
 * 每次刷新随机一套蓝色背景 + 随机 slogan 后半句 + 入场动画 + 上半屏词云。
 */
export default class KapokLanding extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    // 每次挂载（刷新）随机选择背景与 slogan
    this.theme = pick(BLUE_THEMES);
    this.suffix = pick(SLOGAN_SUFFIX);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    document.body.classList.add('kapok-landing');
  }
  onremove(vnode) {
    document.body.classList.remove('kapok-landing');
    super.onremove(vnode);
  }

  // 委托给头部（menu bar）那个可用的登录/注册控件：
  // core 的弹窗是懒加载 chunk，扩展里静态/动态 import 裸模块都拿不到，
  // 而头部按钮的 onclick 由 core 自己绑定（相对路径动态 import）始终可用。
  clickHeaderAuth(re) {
    const btns = Array.from(document.querySelectorAll('.Header-secondary .Button--link, .Header .Button--link'));
    const target = btns.find(b => re.test((b.textContent || '').trim()));
    if (target) target.click();
  }
  openLogin() {
    this.clickHeaderAuth(/登录|Log in/i);
  }
  openSignup() {
    this.clickHeaderAuth(/注册|Sign up/i);
  }
  view() {
    const logoUrl = app.forum.attribute('logoUrl');
    const title = app.forum.attribute('title') || '华南木棉Plus';
    const [c1, c2, c3] = this.theme;
    return m("div", {
      className: "KapokLanding",
      style: `background:linear-gradient(165deg, ${c1} 0%, ${c2} 48%, ${c3} 100%)`
    }, m("div", {
      className: "KapokLanding-quotes",
      "aria-hidden": "true"
    }, QUOTES.map((_ref, i) => {
      let [board, text, top, left, size, rot, delay] = _ref;
      return m("span", {
        key: i,
        className: "KapokLanding-quote",
        style: `top:${top}%;left:${left}%;font-size:${size}px;transform:rotate(${rot}deg);animation-delay:${delay}s;--qop:${(0.45 + i % 4 * 0.15).toFixed(2)}`
      }, m("em", null, "\u201C", text, "\u201D"), m("strong", null, "[", board, "]"));
    })), m("div", {
      className: "KapokLanding-core"
    }, m("h1", {
      className: "KapokLanding-slogan kapok-anim-1"
    }, t('sloganPre'), m("strong", null, t('sloganBrand')), t('sloganSep'), this.suffix), m("div", {
      className: "KapokLanding-domain kapok-anim-2"
    }, m("span", {
      className: "KapokLanding-domainText"
    }, window.location.host, m("span", {
      className: "KapokLanding-caret"
    })), m("span", {
      className: "KapokLanding-mouse"
    }, m("svg", {
      className: "MaterialIcon",
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, m("path", {
      d: MOUSE_PATH
    })))), m("div", {
      className: "KapokLanding-brand kapok-anim-3"
    }, logoUrl ? m("img", {
      src: logoUrl,
      alt: ""
    }) : m(MaterialIcon, {
      name: "language",
      className: "KapokLanding-flower"
    }), m("span", {
      className: "KapokLanding-name"
    }, title), m("span", {
      className: "KapokLanding-sub"
    }, t('sub'))), m("div", {
      className: "KapokLanding-actions kapok-anim-4"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.openLogin()
    }, t('login')), m(Button, {
      className: "Button",
      onclick: () => this.openSignup()
    }, t('signup')), m("a", {
      className: "Button",
      href: "/about"
    }, t('about')), m("a", {
      className: "Button",
      href: "/covenant"
    }, t('covenant')), m("a", {
      className: "Button Button--link",
      href: "/alumni"
    }, t('alumni'))), m("div", {
      className: "KapokLanding-footer kapok-anim-5"
    }, t('footer'))));
  }
}
flarum.reg.add('kapok-plus-site', 'forum/components/KapokLanding', KapokLanding);